import { ReactNode } from 'react';

import { AllEntryTypes } from '../../models/Content';
import { getBlockVisibility } from '../../utils/shouldRenderBlock';
import { BlockVisibility } from './BlockVisibility';

export const renderWithBlockVisibility = (contentItem: AllEntryTypes | undefined, children: ReactNode) => {
    if (!children || !getBlockVisibility(contentItem)) {
        return children ?? null;
    }

    return <BlockVisibility contentItem={contentItem}>{children}</BlockVisibility>;
};
